import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@material-ui/core/styles';
import {  Checkbox, FormGroup, Hidden, InputLabel, Select,  MenuItem, TextField } from '@material-ui/core';
import { Button, Backdrop, ListItemButton, CircularProgress } from '@mui/material';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid'
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';

import ModalDiagnoses from './ModalDiagnoses';
import ModalTreatment from './ModalTreatment';
import ModalReferral from './ModalReferral';
import {v4 as uuid} from "uuid"; 
import moment from 'moment';
import 'moment/locale/es';
import ModalEmpresaLaboral from './ModalEmpresaLaboral';

const url = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/history/create";

function getRealAge(dateString) {

    if(!dateString || dateString == null) {
        return "";
    }
var starts = moment(dateString);
var ends   = moment();
var duration = moment.duration(ends.diff(starts));

return duration.years() + " años "+ duration.months()  +" meses";
}

export default function UpdateHistoryMedical(props) {
   
    const [open, setOpen] = React.useState(false);
    const [openEmpresaLaboral, setOpenEmpresaLaboral] = React.useState(false);
    
    const [openLoader, setOpenLoader] = React.useState(false);

    const handleOpen = () =>  {
        setOpen(true);
    }
    

    const handleOpenEmpresaLaboral = () =>  {
        setOpenEmpresaLaboral(true);
    }

    const handleClose = () => {
        setOpen(false);
        setOpenEmpresaLaboral(false);
        setOpenReferrals(false);
        setOpenTreatments(false);
    }

    const addDiagnosis = (diagnosis) => {
        //diagnosis.id = uuid();
       // console.log(JSON.stringify(diagnosis));
        if(body.diagnoses.length > 0 ){
            body.diagnoses = body.diagnoses.concat(diagnosis);
          } else {
            body.diagnoses.push(diagnosis);
          }
        setOpen(false);
    }
    const addEmpresa = (empresa ) => {
         empresa.id = uuid();
        if(body.companies.length > 0 ){
            body.companies = body.companies.concat(empresa);
          } else {
            body.companies.push(empresa);
          }
        setOpenEmpresaLaboral(false);
    }

    const handleChangeDate = (newValue) => {
        setBody({
            ...body,
            ["assessmentDate"]: newValue
        })
    };

    const handleChangeDateDesde = (newValue) => {
        setBody({
            ...body,
            ["desde"]: newValue
        })
    };

    const handleChangeDateHasta = (newValue) => {
        setBody({
            ...body,
            ["hasta"]: newValue
        })
    };

      //console.log("Reading evolutions: -->> " + JSON.stringify(props.affiliateInfo) + " read index " + props.indexEvolution)
    const [body, setBody] = useState(props.affiliateInfo.evolutions[props.indexEvolution]);
    


    const [evolutionToCut, setPreviousEvolutions] = useState(props.affiliateInfo.evolutions);
    const previousEvolutions = evolutionToCut.filter(evolution => evolution.id != null);
    const [indexEvolution, setIndexEvolution] = useState(-1);
    const changeOfEvolutions = e => {
        const {value } = e.target;
        //console.log("value of evolutions es ____ " + value);
        setIndexEvolution(value);
        let bodyToUse;
        if(value == -1) {
            bodyToUse = props.affiliateInfo.evolutions[props.indexEvolution];
        } else {
            bodyToUse = props.affiliateInfo.evolutions[value];
        }
        bodyToUse.useBarthel = Number(bodyToUse.barthel.score) != -1;
        setBody(bodyToUse);
    }

    const columnsTreatments = [
        { field: 'description', headerName: 'Medicamento',  headerAlign: 'center', width: 330 },
        { field: 'quantity', headerName: 'Cantidad',  headerAlign: 'center', align: 'center', width: 140 },
        { field: 'frecuencia', headerName: 'Frecuencia',  headerAlign: 'center', width: 260, valueGetter: (params) =>
        ` Cada  ${params.row.every || ''} ${params.row.everyTime || ''}  durante 
          ${params.row.duration || ''}  ${params.row.durationTime || ''}`},
       
        { field:'editar', headerName: 'Action', align: 'center', headerAlign: 'center', sortable: false, renderCell: (params) => {
            return (
                <div>
                    <ListItemButton onClick={() => {
                          body.treatments = body.treatments.filter(treatment => treatment.id != params.row.id);
                          deleteItem("treatments", body.treatments);
                    }}>
                    <DeleteIcon />
                    </ListItemButton>
                </div>
            );
        } }
    ];

    const columnsReferrals = [
        { field: 'description', headerName: 'Remitido a:', width: 450 },
        { field: 'observations', headerName: '	Observaciones', width: 450 },
        { field:'editar', headerName: 'Action', align: 'center', headerAlign: 'center', sortable: false, renderCell: (params) => {
            return (
                <div>
                    <ListItemButton onClick={() => {
                        body.referrals = body.referrals.filter(referral => referral.id != params.row.id);
                        deleteItem("referrals", body.referrals);
                    }}>
                    <DeleteIcon />
                    </ListItemButton>
                </div>
            );
        } }
    ];
    const [openReferrals, setOpenReferrals] = React.useState(false);
    const [openTreatments, setOpenTreatments] = React.useState(false);

    const handleOpenReferrals = () =>  {
        setOpenReferrals(true);
    }
    const handleOpenTreatments = () =>  {
        setOpenTreatments(true);
    }

    const addReferrals = (referral) => {
        referral.id = uuid();
        
        if(body.referrals.length > 0 ){
            body.referrals = body.referrals.concat(referral);
          } else {
            body.referrals.push(referral);
          }
        setOpenReferrals(false);
    }

    const addTreatments = (treatment) => {
        treatment.id = uuid();
      if(body.treatments.length > 0 ){
        body.treatments = body.treatments.concat(treatment);
      } else {
        body.treatments.push(treatment);
      }
        setOpenTreatments(false);
    }

    const  deleteItem = ( name, value) => {
        setBody({
			...body,
			[name]: value
		})
    }
    const handleChangeNormal = e => {
		setBody({
			...body,
			[e.target.name]: e.target.value
		})
	}
    const handleChange = e => {
        const { id, name, value } = e.target;
        console.log("id " + id + " name " + name + " values " + value );
        //console.log("id " + id + " name " + name + " values " + value 
        //+ " labelId " + labelId +  "  " + JSON.stringify(e.target));
        setBody(body => ({
          ...body,
      
          [id]: {
            ...body[id],
      
                  [name]: value
               
          }
        }));

    
      };

      const activeTableIncapacidad = e => {
        if (e.target.checked) {
            if(Number(body.barthel.score) === -1) {
                body.barthel.score = 0;
            }
        } else {
            body.barthel.score = -1;
        }
        setBody({
          ...body,
          [e.target.name]: e.target.checked
      })
    }
      const onSubmit = (props, redirect) => {
        if(indexEvolution != -1) {
            return;
        }
        props.affiliateInfo.medicalTeam = props.user;
      //  console.log("medicooo " + JSON.stringify(props.user))
        props.affiliateInfo.evolutions[props.indexEvolution] = body;
       // console.log("Saving submit: " + JSON.stringify(props.affiliateInfo))
        props.setAffiliate(props.affiliateInfo);
       
        setOpenLoader(true);

        axios.post(url, props.affiliateInfo).then(response => { 
            //console.log(response.data);
            if(redirect){
                props.changeMenu(12)
            }
            setOpenLoader(false);
          });
	 }

     const columns = [
        { field: 'id', headerName: 'Codigo', width: 140 },
        { field: 'description', headerName: 'Diagnóstico', width: 300 },
        { field: 'classDiagnosis', headerName: 'Clase diagnóstico', width: 240 },
        { field: 'typeDiagnosis', headerName: 'Tipo diagnóstico', width: 240 },
        { field:'editar', headerName: 'Action', align: 'center', headerAlign: 'center', sortable: false, renderCell: (params) => {
            return (
                <div>
                    <ListItemButton onClick={() => {
                        body.diagnoses = body.diagnoses.filter(diagnose => diagnose.id != params.row.id);
                        deleteItem("diagnoses", body.diagnoses);

                    }}>
                    <DeleteIcon />
                    </ListItemButton>
                </div>
            );
        } }
    ];
    const columnsEmpresaLaboral = [
        { field: 'companyName', headerName: 'Empresa',  headerAlign: 'center', width: 140 },
        { field: 'occupation', headerName: 'Cargo',  headerAlign: 'center', align: 'center', width: 140 },
        { field: 'workingStart', headerName: 'Fecha ingreso',  headerAlign: 'center', width: 140},
        { field: 'yearsWorking', headerName: 'Antiguedad',  headerAlign: 'center', align: 'center', width: 140 },
        { field: 'currencyJob', headerName: 'Empresa Actual',  headerAlign: 'center', align: 'center', width: 140 },
        
        { field: 'fisicos', headerName: 'fisicos',  headerAlign: 'center', align: 'center', width: 140,
        valueGetter: (params) => 
        `${params.row.fisicos ? 'SI' : 'NO' || ' '}` },
        { field: 'quimicos', headerName: 'quimicos',  headerAlign: 'center', align: 'center', width: 140 ,
        valueGetter: (params) => 
        `${params.row.quimicos ? 'SI' : 'NO' || ' '}`},
        { field: 'biologicos', headerName: 'biologicos',  headerAlign: 'center', align: 'center', width: 140 ,
        valueGetter: (params) => 
        `${params.row.biologicos ? 'SI' : 'NO' || ' '}`},
        { field: 'ergonomicos', headerName: 'ergonomicos',  headerAlign: 'center', align: 'center', width: 140 ,
        valueGetter: (params) => 
        `${params.row.ergonomicos ? 'SI' : 'NO' || ' '}`},
        { field: 'psicosociales', headerName: 'psicosociales',  headerAlign: 'center', align: 'center', width: 140 
        ,
        valueGetter: (params) => 
        `${params.row.psicosociales ? 'SI' : 'NO' || ' '}`},
        
        { field:'editar', headerName: 'Action', align: 'center', headerAlign: 'center', sortable: false, renderCell: (params) => {
            return (
                <div>
                    <ListItemButton onClick={() => {
                          body.companies = body.companies.filter(companies => companies.id != params.row.id);
                          deleteItem("companies", body.companies);
                    }}>
                    <DeleteIcon />
                    </ListItemButton>
                </div>
            );
        } }
    ];
 
    return (
       <div>
        <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 3 }}>
            <Typography variant="h6">Datos Personales</Typography>
             <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
                <Grid container spacing={1}  >

                    <Grid item xs={12} sm={6} md={4} >
                        <Box color='GrayText' fontSize={20} >
                            Nombre: {props.affiliateInfo.patient.firstName} {props.affiliateInfo.patient.secondName} {props.affiliateInfo.patient.lastName} {props.affiliateInfo.patient.secondLastName}
                          </Box>

                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20} >
                            Identificacion: {props.affiliateInfo.patient.id} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            Edad:  {getRealAge(props.affiliateInfo.patient.birthday)} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            Direccion:  {props.affiliateInfo.patient.address} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            Sexo:  {props.affiliateInfo.patient.gender} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                            EPS:  {props.affiliateInfo.patient.eps} 
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Box color='GrayText' fontSize={20}>
                        <InputLabel id="evolutionsLabel">Evoluciones</InputLabel>
                        <Select
                            labelId="evolutionsLabel"
                            id="evolutions"
                            name="evolutions"
                            defaultValue={-1}
                            label="Evoluciones"
                            onChange={changeOfEvolutions}
                        >
                            <MenuItem value={-1}> Evolucionar  </MenuItem>
                            {previousEvolutions.map((ev,index)=>{
                                return <MenuItem value={index}> {ev.createDate} </MenuItem>;
                                }
                            )}
                           
                        </Select>
                        </Box>
                    </Grid>


                </Grid>
            </Paper>
            
            
            <Paper  sx={{ my: 2, mx: 'auto', p: 2 }}>
            <Button onClick={handleOpenEmpresaLaboral} hidden={indexEvolution != -1} variant="outlined">
             Agregar Empresa
            </Button>
            {(openEmpresaLaboral) ? <ModalEmpresaLaboral handleClose={handleClose} addEmpresa={addEmpresa}></ModalEmpresaLaboral> : ''}
            
            {(body.companies.length > 0) ?
            <DataGrid
                rows={body.companies}
                columns={columnsEmpresaLaboral}
                pagination
                 checkboxSelection={true}
                autoHeight= {true} 
            />: '' }
          </Paper> 

          <Typography   variant="h6">TIPO DE CONTINGENCIA</Typography>
            <Paper  sx={{ my: 2, mx: 'auto', p: 2 }}>
     
              <form>
                <Grid container spacing={2} > 

                    <Grid item xs={12} >
                            <div>
                            <InputLabel id="stateLabel">TIPO DE CONTINGENCIA</InputLabel>
                            <select
                                    labelId="stateLabel"
                                    id="contintegnciasType"
                                    name="accidenteTrabajo"
                                    value={body.contintegnciasType.accidenteTrabajo}
                                    onChange={handleChange}
                                    disabled={indexEvolution != -1}
                                    label="Contingencia">
                                    
                                    <option value="ACCIDENTE DE TRABAJO(AT)">ACCIDENTE DE TRABAJO(AT)</option>
                                    <option value="ENFERMEDAD LABORAL(EL)">ENFERMEDAD LABORAL(EL)</option>
                                   
                                                                       
                                </select>
                            </div>
                       
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>ORIGEN</Typography>
                        <TextField
                            id='contintegnciasType'
                            name='origen'
                            value={body.contintegnciasType.origen}
                            onChange={handleChange}
                            disabled={indexEvolution != -1}
                            variant='outlined'
                            multiline
                            fullWidth
                            minRows={3}
                            aria-label="minimum height"
                         />
                   
                </Grid>
                    
                   
                </Grid>
                </form>
             
            </Paper>
            <Typography variant="h6">Generalidades</Typography>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
        {/*<Paper   sx={{p: '50px', borderRadius: '10px', borderColor: 'black', my: 2, mx: 'auto'}} variant="outlined">
            */}
              <form>
                <Grid container spacing={2} > 

                <Grid item xs={12} sm={6} md={4}>
                    
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileDatePicker
                                id='assessmentDate'
                                name='assessmentDate'
                                label="Fecha Valoración de Paciente."
                                inputFormat="MM/dd/yyyy"
                                value={body.assessmentDate}
                                onChange={handleChangeDate}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                       
                    
                    </Grid>
                
                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="externalCauseLabel">Causa Externa</InputLabel>
                                <select
                                    labelId="externalCauseLabel"
                                    id='generalities'
                                    name="externalCause"
                                    disabled={indexEvolution != -1}
                                    value={body.generalities.externalCause}
                                    onChange={handleChange}
                                    label="Causa Externa">
                                    <option value={"OTRA"}>OTRA</option>
                                    <option value={"ACCIDENTES"}>ACCIDENTES</option>                            
                                </select>
                            </div>
                       
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                        
                            <Typography variant='h6' color='GrayText' component='h2' gutterBottom >Motivo</Typography>
                            <TextField
                                id='generalities'
                                name='reason'
                                value={body.generalities.reason}
                                onChange={handleChange}
                                disabled={indexEvolution != -1}
                                variant='outlined'
                                multiline
                                minRows={5}
                                fullWidth
                                aria-label="minimum height"
                                />
                       
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        
                            <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Enfermedad Actual</Typography>
                            <TextField
                                id='generalities'
                                name='illness'
                                fullWidth
                                value={body.generalities.illness}
                                onChange={handleChange}
                                disabled={indexEvolution != -1}
                                variant='outlined'
                                multiline
                                minRows={5}
                                aria-label="minimum height"
                             />
                       
                    </Grid>
                   
                </Grid>
                </form>
             
            </Paper>

            <Typography  variant="h6">Examen Físico</Typography>
            
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            
              <form>
                <Grid container spacing={2} > 
                   
                    
                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Cabeza</Typography>
                    <TextField
                        id='physicalExam'
                        name='head'
                        value={body.physicalExam.head}
                        onChange={handleChange}
                        disabled={indexEvolution != -1}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

   

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Cuello</Typography>
                    <TextField
                        id='physicalExam'
                        name='neck'
                        value={body.physicalExam.neck}
                        onChange={handleChange}
                        disabled={indexEvolution != -1}
                        variant='outlined'
                        multiline
                        minRows={3}
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Torax (Mamás - Cardiorespiratorio)</Typography>
                    <TextField
                        id='physicalExam'
                        name='chest'
                        value={body.physicalExam.chest}
                        onChange={handleChange}
                        disabled={indexEvolution != -1}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Abdomen</Typography>
                    <TextField
                        id='physicalExam'
                        name='abdomen'
                        value={body.physicalExam.abdomen}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Genitourinario</Typography>
                    <TextField
                        id='physicalExam'
                        name='genitourinary'
                        value={body.physicalExam.genitourinary}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Osteomuscular Miembro Superior</Typography>
                    <TextField
                        id='physicalExam'
                        name='musculoskeletal'
                        value={body.physicalExam.musculoskeletal}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        minRows={5}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Osteomuscular Miembro Inferior</Typography>
                    <TextField
                        id='physicalExam'
                        name='generalAspect'
                        value={body.physicalExam.generalAspect}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        minRows={5}
                        multiline
                        fullWidth
                        aria-label="minimum height"
                        />
                
                </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Piel y Faneraz</Typography>
                    <TextField
                        id='physicalExam'
                        name='skin'
                        value={body.physicalExam.skin}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Neurológico</Typography>
                    <TextField
                        id='physicalExam'
                        name='neurological'
                        value={body.physicalExam.neurological}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>
                  
                    <Grid item xs={12} sm={12} md={12}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Gonometria pasiva</Typography>
                    <TextField
                        id='physicalExam'
                        name='visualAcuity'
                        value={body.physicalExam.visualAcuity}
                        disabled={indexEvolution != -1}
                        onChange={handleChange}
                        variant='outlined'
                        minRows={3}
                        multiline
                        fullWidth
                        aria-label="minimum height"/>
                
                    </Grid>
                
                 </Grid>
                 </form>
            </Paper>
          

            
            <Grid item xs={12} >
                            <div>
                            <InputLabel id="tipoReintegroLabel">TIPO DE REINTEGRO</InputLabel>
                                <Select
                                    labelId="tipoReintegroLabel"
                                    id="tipoReintegro"
                                    name="tipoReintegro"
                                    value={body.tipoReintegro}
                                    onChange={handleChangeNormal}
                                    label="TIPO DE REINTEGRO">
                                    <MenuItem value={"SIN MODIFICACIONES"}>SIN MODIFICACIONES</MenuItem>
                                    <MenuItem value={"CON MODIFICIACIONES"}>CON MODIFICIACIONES</MenuItem>
                                    <MenuItem value={"REUBICACION TEMPORAL"}>REUBICACION TEMPORAL</MenuItem>
                                    <MenuItem value={"REUBICACION DEFINITIVA"}>REUBICACION DEFINITIVA</MenuItem>
                                    <MenuItem value={"RECONVERSION DE MANO DE OBRA"}>RECONVERSION DE MANO DE OBRA</MenuItem>
                                   
                                    
                                </Select>
                            </div>
                       
                    </Grid>
            

        <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            <Button onClick={handleOpen} hidden={indexEvolution != -1} variant="outlined">
             Agregar Diagnostico
            </Button>
            {(open) ? <ModalDiagnoses handleClose={handleClose} addDiagnosis={addDiagnosis}></ModalDiagnoses> : ''}
            
            {(body.diagnoses.length > 0) ?
            <DataGrid
                rows={body.diagnoses}
                columns={columns}
                pagination
                 checkboxSelection={true}
                autoHeight= {true} 
            />: '' }
          </Paper> 

          <Paper  sx={{ my: 2, mx: 'auto', p: 2 }}>
          <Button  onClick={handleOpenTreatments} hidden={indexEvolution != -1} variant="outlined">
             Agregar Tratamiento
            </Button>
            {(openTreatments) ? <ModalTreatment handleClose={handleClose} addTreatments={addTreatments}></ModalTreatment> : ''}
            
            {(body.treatments.length > 0) ?
          
           <DataGrid
                rows={body.treatments}
                columns={columnsTreatments}
                pagination
                checkboxSelection={true}
                autoHeight= {true} 
            />: '' }
           
         
          </Paper>

          <Paper  sx={{ my: 2, mx: 'auto', p: 2 }}>
          <Button  onClick={handleOpenReferrals} hidden={indexEvolution != -1} variant="outlined">
             Agregar Remisiones
            </Button>
            {(openReferrals) ? <ModalReferral handleClose={handleClose} addReferrals={addReferrals}></ModalReferral> : ''}
            
            {(body.referrals.length > 0) ?
         
           <DataGrid
                rows={body.referrals}
                columns={columnsReferrals}
                pagination
                checkboxSelection={true}
                autoHeight= {true} 
                
                />: '' }
           
        
          </Paper>

          

          <Typography  variant="h6">Plan</Typography>
            <Paper sx={{ my: 2, mx: 'auto', p: 2 }}>
            
            <form>
              <Grid container spacing={2} > 
                 
                  <Grid item xs={12} sm={12} md={12}>
                  
                  <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Descripcion</Typography>
                  <TextField
                      id='plan'
                      name='descriptions'
                      value={body.plan.descriptions}
                      onChange={handleChange}
                      disabled={indexEvolution != -1}
                      variant='outlined'
                      aria-label="minimum height"
                      multiline
                      minRows={5}
                      fullWidth/>
              
                  </Grid>

              

                
               </Grid>
               </form>
          </Paper>


          <FormGroup>
          <FormControlLabel   label="Necesita Incapacidad"  control={
           <Checkbox 
           name="useBarthel"
           id='useBarthel'
           checked={body.useBarthel}
           disabled={indexEvolution != -1}
            onChange={activeTableIncapacidad}
            />
          } />
          </FormGroup>
         <Hidden xsUp={!body.useBarthel}>
          <Typography  variant="h6">INCAPACIDADES</Typography>
            <Paper  sx={{ my: 2, mx: 'auto', p: 2 }}>
        
        
              <form>
                <Grid container spacing={2} > 

                <Grid item xs={12} sm={6} md={4}>
                    
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileDatePicker
                                id='desde'
                                name='desde'
                                label="Desde"
                                inputFormat="MM/dd/yyyy"
                                value={body.desde}
                                onChange={handleChangeDateDesde}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                       
                    
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileDatePicker
                                id='hasta'
                                name='hasta'
                                label="Hasta"
                                inputFormat="MM/dd/yyyy"
                                value={body.hasta}
                                onChange={handleChangeDateHasta}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                       
                    
                    </Grid>
                
                   
  
                </Grid>
                </form>
             
            </Paper>
         </Hidden>

        
         <Typography  variant="h6">RECOMENDACIONES</Typography>
            <Paper  sx={{ my: 2, mx: 'auto', p: 2 }}>
              <form>
                <Grid container spacing={2} > 
                <Grid item xs={12} sm={6} md={4}>
                <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Recomendaciones</Typography>
                    <TextField
                        id='conclusionesID'
                        name='conclusiones'
                        value={body.conclusiones}
                        disabled={indexEvolution != -1}
                        onChange={handleChangeNormal}
                        variant='outlined'
                        multiline
                        minRows={3}
                        fullWidth
                        aria-label="minimum height"/>
                </Grid>
                </Grid>
              </form>
            </Paper>
       
          <Grid container spacing={2} >
          <Grid item xs={12} sm={6} md={4}>
                
                <Button 
               // type="submit" 
                variant="contained" 
                color="primary" 
                display="inline" 
                //onClick={() => buttonSave(props)}
                onClick={() => {
                   
                    if (indexEvolution != -1) {
                        //props.affiliateInfo.evolutions[indexEvolution] = body;
                        props.setIndexEvolution(indexEvolution);
                        props.setAffiliate(props.affiliateInfo);
                        props.changeMenu(12)
                    } else {
                        
                        onSubmit(props, true);
                    }
                    
                    }}>
                    Cerrar Historia
                </Button>
                </Grid>
         </Grid>
        </Box>

<Backdrop
sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
open={openLoader}>
<CircularProgress color="inherit" />
</Backdrop>
</div>
    );
}